import React, { memo, useState } from 'react';
import classNames from 'classnames';
import { TextLink } from '../TextLink';
import styles from './ProductPodImage.module.scss';
/**
 * @tdr
 */
var ProductPodImage = memo(function (_a) {
    var _b;
    var _c = _a.dimmed, dimmed = _c === void 0 ? false : _c, imageSrc = _a.imageSrc, linkClassName = _a.linkClassName, linkComponent = _a.linkComponent, linkHref = _a.linkHref, linkRel = _a.linkRel, linkTarget = _a.linkTarget, loading = _a.loading, onClick = _a.onClick, productName = _a.productName;
    var _d = useState(false), error = _d[0], setError = _d[1];
    if (!imageSrc || !linkHref || !productName)
        return null;
    var description = "view product details for ".concat(productName);
    var handleError = function () {
        setError(true);
    };
    return (React.createElement(TextLink, { "aria-label": description, className: classNames(linkClassName, styles.productPodImage, (_b = {},
            _b[styles.dimmed] = dimmed,
            _b)), component: linkComponent, "data-actiontype": "redirect", "data-origincomponent": "ProductPod", "data-shortdescription": description, href: linkHref, onClick: onClick, rel: linkRel, size: "small", target: linkTarget }, error ? (productName) : (React.createElement("img", { alt: productName, height: "auto", itemProp: "image", loading: loading, onError: handleError, src: imageSrc, width: "100%" }))));
});
ProductPodImage.displayName = 'ProductPodImage';
export default ProductPodImage;
//# sourceMappingURL=ProductPodImage.js.map